export const PERMISSIONS = {
    reports: [
        'reports',
        'reports.partner_payout',
        'reports.debtor',
        'reports.customer_anchor_information',
        'reports.limit',
        'reports.repayment_advice',
        'reports.excess_balance',
        'reports.customer_portfolio',
        'reports.roi_computation',
        'reports.disbursement',
        'reports.collection',
        'reports.trial_balance',
        'reports.program_portfolio',
        'reports.upcoming_dues',
        'reports.charges_summary',
        'reports.gl',
        'reports.gst',
        'reports.borrowers',
    ],
    leads: ['leads', 'leads.kyc.complete', 'leads.kyc.approve', 'leads.bre.approve'],
    leads_all: ['leads'],
    leads_kyc_pending: ['leads.kyc.complete'],
    leads_bre_pending: ['leads.bre.approve'],
    credit: ['leads.cam.submit', 'leads.cam.approve'],
    credit_pending_underwriting: ['leads.cam.submit'],
    ops: [
        'leads.agreement_signings',
        'leads.mandates',
        'leads.pdcs',
        'leads.fees',
        'leads.insurances',
        'leads.assessments',
        'leads.activation.approve',
        'invoices',
        'invoices.create',
        'invoices.approvals',
        'invoices.approve',
        'invoices.approve_anomaly',
    ],
    ops_signing: ['leads.agreement_signings'],
    ops_mandates: ['leads.mandates'],
    ops_pdcs: ['leads.pdcs'],
    ops_fee: ['leads.fees_charges', 'leads.fee_charges'],
    ops_insurance: ['leads.insurances'],
    ops_assessment: ['leads.assessments'],
    ops_activation: ['leads.activation'],
    accounts: [
        'payouts',
        'payouts.approvals',
        'payouts.process',
        'payouts.approve',
        'records',
        'records.create',
        'records.process',
    ],
    accounts_payouts: ['payouts', 'payouts.approvals', 'payouts.process', 'payouts.approve'],
    accounts_records: ['records', 'records.create', 'records.process'],
    drawdowns: ['invoices', 'invoices.create', 'invoices.approve'],
    banking: ['records'],
    approvals: [
        'leads.approve_kyc',
        'leads.kyc.approve',
        'leads.bre.approve',
        'leads.cam.approve',
        'leads.activation.approve',
        'leads.invoices.approve',
        'leads.invoices.approve_anomaly',
        'leads.payouts.approve',
        'leads.repayments.process',

        'invoices.approve',
        'invoices.approve_anomaly',
        'payouts.approve',
        'records.process',
    ],
    approvals_kyc: ['leads.approve_kyc', 'leads.kyc.approve'],
    approvals_bre: ['leads.bre.approve'],
    approvals_credit: ['leads.cam.approve'],
    approvals_activation: ['leads.activation.approve'],
    approvals_drawdown: ['leads.invoices.approve', 'invoices.approve'],
    approvals_drawdown_anomaly: ['leads.invoices.approve_anomaly', 'invoices.approve_anomaly'],
    approvals_payouts: ['leads.payouts.approve', 'payouts.approve'],
    approvals_records: ['leads.repayments.process', 'records.process'],
    admin: ['companies', 'users', 'ledger', 'programs', 'configs'],
    admin_companies: ['companies'],
    admin_users: ['users'],
    admin_ledger_config: ['ledger'],
    admin_programs: ['programs'],
    admin_configs: ['configs'],
};
